module.exports = __webpack_public_path__ + "img/AG.221e10a3.svg";